import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Container } from '@gasbuddy/react-components';
import styles from './Banner.module.css';

const TINT_VALUE = 0.55;

const cx = classnames.bind(styles);

export const Banner = ({
  className,
  darker,
  dramatic,
  backgroundImage,
  backgroundColor,
  container,
  children,
  height,
  parallax,
  ...other
}) => {
  const inlineStyles = {};

  if (backgroundImage) {
    if (darker) {
      inlineStyles.backgroundImage = `linear-gradient(rgba(0, 0, 0, ${TINT_VALUE}), rgba(0, 0, 0, ${TINT_VALUE})), url(${backgroundImage})`;
    } else {
      inlineStyles.backgroundImage = `url(${backgroundImage})`;
    }
  } else if (backgroundColor) {
    inlineStyles.backgroundColor = backgroundColor;
  }

  if (height) {
    inlineStyles.height = height;
  }

  return (
    <div
      className={cx('banner', { bannerDramatic: dramatic, bannerParallax: height && parallax }, className)}
      style={inlineStyles}
      {...other}
    >
      {container ? <Container>{children}</Container> : children}
    </div>
  );
};

Banner.propTypes = {
  className: PropTypes.string,
  darker: PropTypes.bool,
  dramatic: PropTypes.bool,
  container: PropTypes.bool,
  backgroundImage: PropTypes.string,
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  parallax: PropTypes.bool,
};

Banner.defaultProps = {
  className: null,
  darker: false,
  dramatic: false,
  container: false,
  backgroundImage: null,
  backgroundColor: null,
  children: null,
  height: null,
  parallax: false,
};
